import { render, staticRenderFns } from "./PropertyRev.vue?vue&type=template&id=454f4744&"
import script from "./PropertyRev.vue?vue&type=script&lang=js&"
export * from "./PropertyRev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports